import axios from 'axios';

const API_HOST_URL = process.env.REACT_APP_API_URL

export const fetchHolidays = async() =>{
    let holidays: any[] = [];
    await axios.get(`${API_HOST_URL}/api/systemsetup/holiday/`)
      .then(res => {
        console.log("holidays into state:", res.data);
        holidays.push(...res.data)
      })
      .catch(error => {
          console.log(error);
        })
      return holidays;
  }
